import React from 'react';
import { SiderMenuItem, SubMenuItem } from '@devdept/samolet-ui/lib/features/Layout';
import { Icon } from 'components/Icon';
import { MenuInfo } from 'components/Menu/types';

import {
  AsideMenuItemsKeys,
  AsideMenuItemsRules,
  IAsideMenuCreator,
  ICON_SIZE,
  asideMenuItemsIcons,
  asideMenuItemsPermissions,
  asideMenuItemsRoutes,
  asideMenuItemsRules,
  asideMenuItemsValues,
} from './types';

const renderAsideMenuIcon = (type: AsideMenuItemsKeys) => {
  if (!asideMenuItemsIcons[type] && process.env.NODE_ENV !== 'production')
    throw new Error('Unknown icon type');

  return <Icon type={asideMenuItemsIcons[type]} size={ICON_SIZE} />;
};

const createAsideMenuItem = (
  type: AsideMenuItemsKeys,
  onClick: (value: MenuInfo) => void,
): SubMenuItem => ({
  title: asideMenuItemsValues[type],
  icon: renderAsideMenuIcon(type),
  link: asideMenuItemsRoutes[type],
  key: type,
  onClick,
});

const asideMenuFilter = (
  { employee, notEmployee, permissions, isAnonymous }: IAsideMenuCreator,
  items: SubMenuItem[],
): SubMenuItem[] =>
  items.filter(item => {
    const itemRules = asideMenuItemsRules[item.key as AsideMenuItemsKeys];
    const itemPermissions = asideMenuItemsPermissions[item.key as AsideMenuItemsKeys];

    if (
      itemPermissions &&
      !itemPermissions?.some(permission => permissions?.includes(permission))
    )
      return false;

    if (itemRules.includes(AsideMenuItemsRules.All)) return true;

    if (employee && itemRules.includes(AsideMenuItemsRules.Employee)) return true;

    if (!isAnonymous && itemRules.includes(AsideMenuItemsRules.NotDemo)) return true;

    if (notEmployee && itemRules.includes(AsideMenuItemsRules.NotEmployee)) return true;

    return false;
  });

export const asideMenuItems = (props: IAsideMenuCreator): SiderMenuItem[] => [
  {
    // Genius structure
    key: '',
    title: '',
    items: asideMenuFilter(
      props,
      Object.values(AsideMenuItemsKeys).map(key =>
        createAsideMenuItem(key, props.onClick),
      ),
    ),
  },
];
